import React, { useState } from 'react'
import contactImage from '../../../assets/img/contact.svg'
import CTA from '../../../components/CTA'
import { contactItems } from '../contactItems'

const ContactDesktop: React.FC = () => {
	const [copiedIndex, setCopiedIndex] = useState<number | null>(null)

	const handleCopyToClipboard = (email: string, index: number) => {
		navigator.clipboard.writeText(email).then(() => {
			setCopiedIndex(index)

			// Reset the copied state after 2 seconds
			setTimeout(() => {
				setCopiedIndex(null)
			}, 2000)
		}).catch(err => {
			console.error('Failed to copy: ', err)
		})
	}

	const handleEmailClick = (email: string) => {
		window.location.href = `mailto:${email}`
	}

  return (
    <section className="w-full min-h-[99vh] flex pt-[120px] justify-center 2xl:items-center relative overflow-visible">
      {/* Contact Image */}
      <div className="absolute bottom-[-60px] right-0 w-2/5 flex justify-center h-auto z-50 opacity-100 2xl:bottom-[-50px]">
        <img 
          src={contactImage} 
          alt="Contact illustration" 
          className="w-[65%] h-full object-contain"
        />
      </div>

      {/* Contact Content */}
      <div className="w-full max-w-6xl flex flex-col items-center relative z-10">
        <h1 className="font-apropal text-[64px] text-black font-bold mb-4 text-center w-full">
          Kontakt
        </h1>
        
        <p className="text-[16px] mb-8 text-center w-1/2">
          Wszystkie treści tworzę samodzielnie. 
          <br />
          Jeśli chcesz pomóc mi działać dalej - wesprzyj mnie na buycoffee! 
          <br />
          <br />
          A jeśli chcesz po prostu pogadać - też super, lubię gadać!
        </p>
        
        <div className="flex space-x-8 mb-64">
          {contactItems.map((item, index) => (
            <div 
              key={index} 
              className="bg-white border rounded-lg p-6 text-center shadow-md w-64 flex flex-col items-center"
            >
              <div 
                className={`flex justify-center mb-4 ${item.email ? 'cursor-pointer' : ''}`}
                onClick={() => item.email && handleCopyToClipboard(item.email, index)}
              >
                <img 
                  src={item.icon} 
                  alt={`${item.description} icon`} 
                  className="w-52 h-20"
                />
              </div>
              {copiedIndex === index ? (
                <p className="text-green-600 text-[13px] mb-2">Skopiowano!</p>
              ) : (
                <CTA 
                  text={item.description}
                  backgroundColor="bg-black"
                  fontColor="text-white"
                  fontSize="text-[13px]"
                  onClick={item.email ? () => handleEmailClick(item.email as string) : undefined}
                  link={item.link}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ContactDesktop